import { default as GoogleAnalyticsService } from './google-analytics.service';

export * from './google-analytics.constants';
export default GoogleAnalyticsService;
